export const BINARY_ANSWERS = {
  Yes: true,
  No: false,
};
